import {
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  TextContainer,
  Layout
} from '@shopify/polaris';
import {
  DetailsPageLayout,
  TabsContainer,
  PageLoading
} from '@nile/components';
import React from 'react';
import styled from 'styled-components';
import { times } from 'lodash';

const SkeletonWrapper = styled.div`
  background-color: white;
  padding: 20px;
  .no-shadow-card {
    margin-left: 10px;
    margin-bottom: 10px;
    box-shadow: none;
    border: 0.1rem solid #f0f0f6;
    border-radius: 10px;
  }
  .pageAct {
    flex-grow: 1;
    justify-content: center;
  }

  .actionsWrapper {
    height: 117px;
    border-bottom: 1px solid #ececec;
    display: flex;
  }
  .rdw-editor-wrapper {
    height: auto !important;
    border-radius: 8px;
    display: flex;
    background: #ffffff;
    flex-direction: column-reverse;
    margin: 2px;
  }
  .rdw-editor-main {
    max-height: 150px;
    overflow: auto;
  }

  .TabPage {
    justify-content: center;
    overflow: auto;
    height: calc(100% - 150px);
    background: #f2f2f7;
  }
  .Polaris-Card {
    border-radius: 8px !important;
  }
  .section-0 {
    width: 100%;
    max-width: 100%;
  }
  .Polaris-Tabs__Title {
    min-width: 15rem;
  }
`;

const DetailPageLoading = (props) => {
  const { tabCount = 2, sectionCount = 1, noTabs = false } = props;
  const getParaContent = () => {
    // 180 - height of card, -1 to subtract the header height
    const count = Math.floor(window.innerHeight / 180) - 1;
    return (
      <>
        {times(count, () => (
          <div className="mt-20 mr-10">
            <TextContainer>
              <SkeletonDisplayText size="medium" />
              <Layout>
                <Layout.Section>
                  <SkeletonBodyText lines={4} />
                </Layout.Section>
              </Layout>
            </TextContainer>
          </div>
        ))}
      </>
    );
  };

  const tabs = times(tabCount, (idx) => ({
    id: idx,
    content: <SkeletonDisplayText size="small" />,
    name: idx,
    accessibilityLabel: idx,
    panelID: idx,
    component: getParaContent()
  }));

  const sections = times(sectionCount, (idx) => ({
    id: idx,
    component: (
      <TabsContainer activeTabIndex={0} tabs={tabs} onTabChange={console.log} />
    )
  }));

  return (
    <>
      {noTabs ? (
        <>
          <SkeletonWrapper>
            <TextContainer>
              <SkeletonDisplayText size="medium" />
              <Layout>
                <Layout.Section>
                  <SkeletonBodyText lines={2} />
                </Layout.Section>
              </Layout>
            </TextContainer>
          </SkeletonWrapper>
          <PageLoading primaryAction={false} secondaryActions={false} />
        </>
      ) : (
        <SkeletonWrapper>
          <DetailsPageLayout
            header={
              <TextContainer>
                <SkeletonDisplayText size="medium" />
                <Layout>
                  <Layout.Section>
                    <SkeletonBodyText lines={2} />
                  </Layout.Section>
                </Layout>
              </TextContainer>
            }
            sections={sections}
          />
        </SkeletonWrapper>
      )}
    </>
  );
};

export default DetailPageLoading;
